"use strict";

module.exports = function(angularModule) {
  angularModule.service("RGSenderConfigModal", function($uibModal, RGSenderConfigService, $timeout) {

    this.open = function() {
      let modalInstance = $uibModal.open({
        controller: ['$scope','$uibModalInstance', function($scope, $uibModalInstance) {
          var vm = this;
          vm.loading = false;
          vm.selectedTab = 'security';
          vm.onTabClick = function(tab) {
            vm.selectedTab = tab;
          }


          var initConfig = function(config) {
            vm.config = config;
            vm.emailStatus = config.fromAddressVerificationStatus;
            vm.dkimVerified = config.dkimVerified;
            vm.fromAddress = config.fromAddress;
            vm.senderName = config.senderName;
            vm.usesCustomDomain = config.usesCustomDomain;
            vm.securityDefaults = angular.copy(config.securityDefaults);

            vm.loading = false;
            if (vm.deliveryConfigForm) {
              vm.deliveryConfigForm.$setPristine();
            }
          };

          modalInstance.opened.then(() => {
            let initialized = RGSenderConfigService.getConfig().then(initConfig);

            initialized.then(function() {
              $scope.$watch("vm.fromAddress", function(newVal) {
                if (newVal != vm.config.fromAddress) {
                  vm.emailStatus = 'NotStarted'
                }
              })
            });
          })


          vm.setEmailAddress = function(emailAddress) {
            vm.loading = true;
            RGSenderConfigService.updateEmailAddress(emailAddress).then(initConfig);
            vm.emailVerificationSent = true;
          };

          vm.refresh = function() {
            vm.loading = true;
            RGSenderConfigService.refreshConfig().then(initConfig);
          };

          vm.close = function(){
            $uibModalInstance.close('cancel');
          }

          vm.save = function() {
            if (!vm.deliveryConfigForm.$valid) {
              return;
            }

            if (vm.fromAddress != vm.config.fromAddress || vm.usesCustomDomain != vm.config.usesCustomDomain || vm.senderName != vm.config.senderName) {
              vm.loading = true;
              if (vm.fromAddress != vm.config.fromAddress) {
                vm.emailVerificationSent = true;
              }
              RGSenderConfigService.updateEmailConfig(vm.usesCustomDomain ? vm.fromAddress : null, vm.senderName).then(initConfig);
            }
            if (!angular.equals(vm.securityDefaults, vm.config.securityDefaults)) {
              RGSenderConfigService.updateSecurity(vm.securityDefaults).then(initConfig);
            }

          }
        }],
        controllerAs: "vm",
        template: require("./senderConfigModal.html")
      });
    }

  });
};
